module.exports = __webpack_public_path__ + "static/LOGO-INNGENIO-02b1cae2d7511c3543fe730118b0cfb5.svg";